<template>
    <div id="mainMenu" class="pure-menu custom-restricted-width">

        <span class="pure-menu-heading">System</span>
        <ul class="pure-menu-list">
            <li class="pure-menu-item"><router-link class="pure-menu-link main-menu-item" to="/" >Home</router-link></li>
            <li class="pure-menu-item" v-if="isInRole([ 'system_admin', 'customer_admin' ])"><router-link class="pure-menu-link main-menu-item" to="/accounts" >Benutzer</router-link></li>
            <li class="pure-menu-item" v-if="isInRole([ 'system_admin' ])"><router-link class="pure-menu-link main-menu-item" to="/customers" >Kunden</router-link></li>
            <li class="pure-menu-item" v-if="isInRole([ 'system_admin' ])"><router-link class="pure-menu-link main-menu-item" to="/modules" >Module</router-link></li>
            <li class="pure-menu-item"><router-link class="pure-menu-link main-menu-item" to="/myprofile" >Mein Profil</router-link></li>
        </ul>

        <span class="pure-menu-heading"  >Inventur</span>
        <ul class="pure-menu-list">
            <li class="pure-menu-item" v-if="isInRole([ 'customer_user', 'customer_admin' ])"><router-link class="pure-menu-link main-menu-item" to="/stocktakings" >Inventuren</router-link></li>
            <li class="pure-menu-item" v-if="isInRole([ 'system_admin' ])"><router-link class="pure-menu-link main-menu-item" to="/stocktakings/admin" >Inventuren</router-link></li>
        </ul>

    </div>
</template>

<script>
import { hasRole } from '@/utils/auth.js'

export default {
  name: 'MainMenu',
  methods: {

      isInRole: function(roles) {

          return hasRole(roles)
      }
  }
}
</script>

<style>

#mainMenu {
    background-color: #6699cc;
    color: white;
    min-height: calc(100vh - 70px);
    padding-top: 40px;
    
}

#mainMenu .pure-menu-link {
    color: white;
    font-size: 1.1rem;
    padding-top: 6px;
    padding-bottom: 6px;
}

#mainMenu .pure-menu-link:hover {
    background-color: #003366;
}

#mainMenu .pure-menu-link:focus {
    background-color: #003366;
}

#mainMenu .pure-menu-heading {
    color: #003366;
}

</style>
